import React, { useEffect, useState } from "react";
import useFetchAppliedJobs from "../Hooks/jobs/useFetchAppliedJobs";
import { Loader } from "../constents/components";
import Job from "../Components/Discover/Job";
import { APPLIED_JOBS_STATUS } from "../constents/jobs";
import { IN_REVIEW, SHORTLISTED } from "../constents/status";

const JOB_STATUS_MAP = {
  "Under Consideration": "under_consideration",
  "Sent offer letter": "sent_offer_letter",
  "Hired": "hired",
  "Rejected": "rejected",
};

const hiredStatuses = Object.values(JOB_STATUS_MAP);

const JobSectionChild = () => {
  const [loading, error, appliedJob, fetchFunction] = useFetchAppliedJobs();
  const JOB_TYPES = [
    { text: "In Review", str: "InReviewJobs" },
    { text: "Shortlisted", str: "ShortlistedJobs" },
    { text: "Final Decision", str: "HiredJobs" },
  ];
  const [currentJobsType, setCurrentJobsType] = useState(JOB_TYPES?.[0]?.str);

  // console.log("Applied jobs are : ", appliedJob);

  const JobsObject = {
    ShortlistedJobs: appliedJob?.filter((item) =>
      SHORTLISTED.includes(item?.applicant_status?.toLowerCase()),
    ),

    HiredJobs: appliedJob?.filter((item) =>
      hiredStatuses.includes(item?.applicant_status?.toLowerCase()),
    ),

    InReviewJobs: appliedJob?.filter((item) =>
      IN_REVIEW.includes(item?.applicant_status?.toLowerCase()),
    ),
  };
  // console.log("Jobs object is : ", JobsObject);

  useEffect(() => {
    fetchFunction();
  }, []);

  return (
    <div className="min-h-screen pb-10">
      <div className="w-full max-w-screen-xl">
        <div className=" flex justify-between">
          <div className=" flex gap-2 items-center">
            <h1 className="flex gap-2 text-sm lg:text-lg">Job Applications</h1>
            {appliedJob?.length && (
              <span className="w-5 h-5 bg-[#fff] rounded-full flex items-center justify-center text-sm font-medium">
                {appliedJob?.length}
              </span>
            )}
          </div>

          <div className=" rounded-full bg-pills-bg-color-900 flex items-center gap-1 p-1">
            {JOB_TYPES.map((item, index) => (
              <div
                key={index}
                onClick={() => setCurrentJobsType(item.str)}
                className={` flex gap-3 items-center ${item.str === currentJobsType ? "text-white bg-primary-color-900" : "text-text-color bg-pills-bg-color-900"} rounded-full px-2 lg:px-4 text-sm lg:text-lg py-1`}
              >
                <span className=" cursor-pointer">{item.text}</span>
                {item.str === currentJobsType && (
                  <span className=" h-6 aspect-square flex items-center justify-center rounded-full bg-white text-black">
                    {JobsObject?.[currentJobsType]?.length ?? 0}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="mt-2 rounded-xl overflow-hidden">
          {loading ? (
            <Loader />
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {appliedJob?.length > 0 ? (
                JobsObject?.[currentJobsType].map((item, index) => (
                  <Job key={index} job={item} />
                ))
              ) : (
                <div className="text-center text-gray-500">
                  No Job Applications
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobSectionChild;
